import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllSuppliersService = (page = 1, limit = 10, search = "") => {
  return HTTP_CLIENT.get(
    `${Endpoint.suppliers.getAllSuppliers}?page=${page}&limit=${limit}&search=${search}`
  );
};

export { GetAllSuppliersService };
